export * from './faimilyAndKidDiscount';

export const groupTimeMinutes = 10;

export function validateMobileNumber(number) {
    const internationalRegex = /^\+?[1-9]\d{9,14}$/;
    const australianRegex = /^(?:\+61|0)4\d{8}$/;
    return internationalRegex.test(number) || australianRegex.test(number);
  }

export const defaultStartTime = "10:00";
export const defaultEndTime = "19:00";
export const defaultSlotSize = 15;
export const defaultMaxPeople = 25;
export const defaultMaxPeoplePerSlot = 13;
export const defaultMaxPeoplePerLocation = {
  "perth": 15
};

export const defaultMaxGroups = 5;

export const SESSION_TIMEOUT = 5 * 60 * 1000; // 5 minutes in ms

export const QuizItems = [
  "Google/Search Engine",
  "Social Media - Instagram/Facebook",
  "Social Media - TikTok",
  "Social Media - Other",
  "Website - Tourism Website",
  "Website - Lifestyle Publisher",
  "Word of Mouth",
  "Radio/TV",
  "Been to House Down Under before",
  "Walked Past/Saw it in the area",
  "Invited by HDU",
  "Other"
];
